import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import './sso-workspace.scss'
import './fleet.scss'

// The SSO section's pages, one click from each other (audit F12: they were
// reachable only through the connections list's kebab menu), in the
// workspace's vocabulary: connections, not providers.
export const SSO_TABS = [
  { to: '/admin/provider/list', label: 'Connections', exact: true },
  { to: '/admin/signin-method', label: 'Sign-in methods' },
  { to: '/admin/provider/domains', label: 'Domains' },
  { to: '/admin/provider/consent-requests', label: 'Consent requests' },
  { to: '/admin/provider/health', label: 'Health' },
  { to: '/admin/provider/findings', label: 'Findings' },
  { to: '/admin/provider/notifications', label: 'Alerts sent' },
  { to: '/admin/provider/jobs', label: 'Jobs' }
]

export const FleetTabs = () =>
  <nav className="sw-tabs" aria-label="single sign-on pages">
    {SSO_TABS.map(tab =>
      <NavLink key={tab.to} to={tab.to} exact={tab.exact} activeClassName="active">
        {tab.label}
      </NavLink>)}
  </nav>

// One SSO page in the connection workspace's language: a pane that scrolls
// itself (.sw-pane), the section's tabs (tabs), then a header with the
// title, one line on what the page is for, and the page's actions (the
// primary one first).
export const FleetPage = ({ title, purpose, actions, tabs, children, testId }) =>
  <div className="sw-workspace sw-pane sw-fleet" data-testid={testId}>
    {tabs && <FleetTabs />}
    <header className="sw-page-head">
      <div className="min-w-0">
        <h1 className="sw-title">{title}</h1>
        {purpose && <p className="sw-sub">{purpose}</p>}
      </div>
      {actions && <div className="sw-page-actions">{actions}</div>}
    </header>
    {children}
  </div>

// A card of content under the header (the workspace's .sw-section).
export const FleetSection = ({ id, title, lede, actions, children }) =>
  <section className="sw-section" id={id} aria-labelledby={title ? `${id}-title` : undefined}>
    {(title || actions) &&
      <div className="sw-subh mb-1">
        {title && <h2 className="h6 fw-semibold m-0" id={`${id}-title`}>{title}</h2>}
        {actions && <div className="d-flex flex-wrap gap-2">{actions}</div>}
      </div>}
    {lede && <p className="sw-hint mb-3" style={{ maxWidth: '72ch' }}>{lede}</p>}
    {children}
  </section>

// Rollup figures in the status strip's look. tiles: { key, label, value,
// detail, tone ('ok' | 'warn' | 'bad'), to }. A tile with `to` is a link to
// where that figure comes from.
export const RollupTiles = ({ tiles, label }) =>
  <div className="sw-strip" role="region" aria-label={label}>
    {tiles.map(tile => {
      const body =
        <>
          <span className="sw-k">{tile.label}</span>
          <span className={`sw-v ${tile.tone || ''}`.trim()}>{tile.value}</span>
          {tile.detail && <span className="sw-d">{tile.detail}</span>}
        </>
      return tile.to
        ? <Link key={tile.key} className="sw-tile" to={tile.to} data-testid={`tile-${tile.key}`}>{body}</Link>
        : <div key={tile.key} className="sw-tile" data-testid={`tile-${tile.key}`}>{body}</div>
    })}
  </div>

// Nothing to show yet: a sentence of guidance and, when there is one, the
// thing to do about it.
export const EmptyState = ({ children, action }) =>
  <div className="sw-empty-state">
    <p>{children}</p>
    {action}
  </div>

// An inline notice: info (default), ok, warn or bad.
export const Notice = ({ tone, children, role }) =>
  <div className={`sw-notice ${tone || ''}`.trim()} role={role}>
    <div>{children}</div>
  </div>
